module.exports = __webpack_public_path__ + "img/5a620b9.jpg";